import React from 'react'
import styled from 'styled-components'
import styles from './banner_breakingnews.scss'
import { invertColor } from '../../../../../../utils';
export default function BreakingNews(props) {

  const { theme, style } = props;



  const Title = styled.span`
        font-family: ${theme?.font || props?.style?.title?.font};
        background-color: ${theme?.secondaryColor || props?.style?.title?.background};
        color: ${theme?.primaryColor || props?.style?.title?.color};
        display: block;
        height: 100%;  
        width: 90px;
        font-family: arial;
        font-size: 11px;
        position: absolute; 
        top: 0px;
        margin-top: 0px;
        margin-left: 0px;
        padding-top: 7px;
        padding-left: 10px;
        z-index: 3;
        &:before {
          content:"";
          position: absolute;
          display: block;
          width: 0px;
          height: 0px;
          top: 0;
          left: -12px;
          border-left:12px solid transparent;
          border-right: 0px solid transparent;
          border-bottom: 30px solid ${theme?.secondaryColor || props?.style?.title?.background};
           
        }
        &:after {
          content:"";
          position: absolute;
          display: block;
          width: 0px;
          height: 0px;
          right: -12px;
          top: 0;
          border-right:12px solid transparent;
          border-left: 0px solid transparent;
          border-top: 30px solid ${theme?.secondaryColor || props?.style?.title?.background};
        }
      
    
    `
  const Text = styled.span`
    font-family: ${theme?.font || props?.style?.text?.font};
    color: ${theme?.secondaryColor || props?.style?.text?.color} !important;
   
`

  return (
    <div className='banner m-0 w-full'>

      <div id="breaking-news-container" style={{ backgroundColor: theme?.primaryColor  || props?.style?.title?.background, color: theme?.secondaryColor || props?.style?.title?.color }} >
        <div id="breaking-news-colour" className="slideup animated" style={{ backgroundColor: theme?.primaryColor || props?.style?.text?.background, color: theme?.secondaryColor || props?.style?.text?.color }}>

        </div>
        <Title className="delay-animated slidein" >
          {props?.title ?? '// BREAKING //'}
        </Title>
        <Text className="breaking-news-headline delay-animated2 fadein marquee" >
          {props?.text ?? "This could be used to announce a breaking news"}
        </Text>
      </div>
    </div>
  )
}
